import React from 'react';
import ReactDOM from 'react-dom';
import './styles/built/index.css';
import Application from './Application';

ReactDOM.render((
    <Application /> // eslint-disable-line
  ), document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js